module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "sports.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:11:59 2018",
		"id": 8856518
	},
	"speakers": [
		{
			"duration": "43.47",
			"confidence": null,
			"name": "F1",
			"time": "3.72"
		},
		{
			"duration": "59.53",
			"confidence": null,
			"name": "F2",
			"time": "47.35"
		},
		{
			"duration": "77.10",
			"confidence": null,
			"name": "F1",
			"time": "106.90"
		}
	],
	"words": [
		{
			"duration": "0.11",
			"confidence": "0.910",
			"name": "Hi",
			"time": "3.72"
		},
		{
			"duration": "0.19",
			"confidence": "0.550",
			"name": "Creighton",
			"time": "3.83"
		},
		{
			"duration": "0.17",
			"confidence": "0.570",
			"name": "volleyball",
			"time": "4.07"
		},
		{
			"duration": "0.38",
			"confidence": "0.700",
			"name": "fans",
			"time": "4.93"
		},
		{
			"duration": "0.02",
			"confidence": "0.620",
			"name": ".",
			"time": "5.31"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "Hi",
			"time": "5.36"
		},
		{
			"duration": "0.40",
			"confidence": "1.000",
			"name": "Dad",
			"time": "5.52"
		},
		{
			"duration": "0.02",
			"confidence": "0.680",
			"name": ".",
			"time": "5.92"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "Happy",
			"time": "5.94"
		},
		{
			"duration": "0.39",
			"confidence": "0.980",
			"name": "Father's",
			"time": "6.21"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "Day",
			"time": "6.60"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "6.99"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "you",
			"time": "7.14"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "7.44"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "all",
			"time": "7.56"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "7.71"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "other",
			"time": "7.80"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "dads",
			"time": "7.98"
		},
		{
			"duration": "0.15",
			"confidence": "0.430",
			"name": "hope you",
			"time": "8.65"
		},
		{
			"duration": "0.11",
			"confidence": "0.770",
			"name": "had",
			"time": "8.88"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "9.00"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "great",
			"time": "9.06"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "day",
			"time": "9.27"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": ".",
			"time": "9.66"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "We",
			"time": "10.14"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "sure",
			"time": "10.29"
		},
		{
			"duration": "0.20",
			"confidence": "0.820",
			"name": "did",
			"time": "10.47"
		},
		{
			"duration": "0.04",
			"confidence": "0.540",
			"name": ".",
			"time": "10.67"
		},
		{
			"duration": "0.12",
			"confidence": "0.900",
			"name": "Over",
			"time": "10.71"
		},
		{
			"duration": "0.14",
			"confidence": "0.820",
			"name": "here",
			"time": "10.83"
		},
		{
			"duration": "0.06",
			"confidence": "0.980",
			"name": "in",
			"time": "10.98"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Budapest",
			"time": "11.04"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "across",
			"time": "11.58"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "11.94"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "world",
			"time": "12.00"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "today",
			"time": "13.32"
		},
		{
			"duration": "0.38",
			"confidence": "1.000",
			"name": "is",
			"time": "13.95"
		},
		{
			"duration": "0.55",
			"confidence": "0.970",
			"name": "day",
			"time": "14.34"
		},
		{
			"duration": "0.04",
			"confidence": "0.630",
			"name": "...",
			"time": "14.91"
		},
		{
			"duration": "0.25",
			"confidence": "0.840",
			"name": "what",
			"time": "14.97"
		},
		{
			"duration": "0.32",
			"confidence": "0.840",
			"name": "day is",
			"time": "15.22"
		},
		{
			"duration": "0.25",
			"confidence": "0.930",
			"name": "it?",
			"time": "15.54"
		},
		{
			"duration": "0.24",
			"confidence": "0.640",
			"name": "day six",
			"time": "15.96"
		},
		{
			"duration": "0.37",
			"confidence": "0.770",
			"name": "day",
			"time": "16.40"
		},
		{
			"duration": "0.40",
			"confidence": "0.410",
			"name": "six",
			"time": "16.77"
		},
		{
			"duration": "0.20",
			"confidence": "0.230",
			"name": "you're",
			"time": "17.19"
		},
		{
			"duration": "0.08",
			"confidence": "0.790",
			"name": "in",
			"time": "17.40"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "Budapest",
			"time": "17.49"
		},
		{
			"duration": "0.16",
			"confidence": "0.560",
			"name": "was",
			"time": "18.67"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "our",
			"time": "18.84"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "first",
			"time": "18.96"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "full",
			"time": "19.23"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "day",
			"time": "19.38"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "here",
			"time": "19.56"
		},
		{
			"duration": "0.48",
			"confidence": "0.990",
			"name": "so",
			"time": "19.80"
		},
		{
			"duration": "0.09",
			"confidence": "0.950",
			"name": "we're",
			"time": "20.67"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "in",
			"time": "20.78"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "20.88"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "beautiful",
			"time": "20.94"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "hotel",
			"time": "21.30"
		},
		{
			"duration": "0.06",
			"confidence": "0.930",
			"name": ".",
			"time": "22.94"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "We",
			"time": "23.07"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "got",
			"time": "23.88"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "up",
			"time": "24.12"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "24.21"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "morning",
			"time": "24.42"
		},
		{
			"duration": "0.56",
			"confidence": "1.000",
			"name": "around",
			"time": "24.87"
		},
		{
			"duration": "0.71",
			"confidence": "0.850",
			"name": "830",
			"time": "25.46"
		},
		{
			"duration": "0.15",
			"confidence": "0.840",
			"name": "had",
			"time": "26.45"
		},
		{
			"duration": "0.05",
			"confidence": "0.790",
			"name": "a",
			"time": "26.65"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "breakfast",
			"time": "26.70"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "and",
			"time": "27.48"
		},
		{
			"duration": "0.11",
			"confidence": "0.440",
			"name": "it's",
			"time": "28.13"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": "a",
			"time": "28.26"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "little",
			"time": "28.29"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "different",
			"time": "28.47"
		},
		{
			"duration": "0.09",
			"confidence": "0.520",
			"name": "than",
			"time": "28.83"
		},
		{
			"duration": "0.10",
			"confidence": "0.490",
			"name": "all",
			"time": "28.94"
		},
		{
			"duration": "0.09",
			"confidence": "0.710",
			"name": "of",
			"time": "29.04"
		},
		{
			"duration": "0.11",
			"confidence": "0.990",
			"name": "the",
			"time": "29.14"
		},
		{
			"duration": "0.36",
			"confidence": "0.590",
			"name": "breakfast",
			"time": "29.25"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we've",
			"time": "29.61"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "had",
			"time": "29.79"
		},
		{
			"duration": "0.98",
			"confidence": "0.730",
			"name": ".",
			"time": "30.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "There",
			"time": "31.59"
		},
		{
			"duration": "0.09",
			"confidence": "0.960",
			"name": "were",
			"time": "31.71"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "hot",
			"time": "31.80"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "dogs",
			"time": "32.04"
		},
		{
			"duration": "0.09",
			"confidence": "0.850",
			"name": "that",
			"time": "32.43"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "were",
			"time": "32.52"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "served",
			"time": "32.64"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "and",
			"time": "33.09"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "french",
			"time": "33.42"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "fries",
			"time": "33.66"
		},
		{
			"duration": "0.33",
			"confidence": "0.880",
			"name": "and",
			"time": "34.56"
		},
		{
			"duration": "0.04",
			"confidence": "0.750",
			"name": "a",
			"time": "35.25"
		},
		{
			"duration": "0.53",
			"confidence": "0.790",
			"name": "rather",
			"time": "35.35"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "strange",
			"time": "35.94"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "breakfast",
			"time": "36.63"
		},
		{
			"duration": "0.37",
			"confidence": "0.980",
			"name": "foods",
			"time": "37.05"
		},
		{
			"duration": "0.03",
			"confidence": "0.610",
			"name": ".",
			"time": "37.43"
		},
		{
			"duration": "0.23",
			"confidence": "0.970",
			"name": "But",
			"time": "37.49"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "I",
			"time": "39.42"
		},
		{
			"duration": "0.21",
			"confidence": "0.980",
			"name": "tried",
			"time": "39.48"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "39.69"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "give",
			"time": "39.78"
		},
		{
			"duration": "0.21",
			"confidence": "0.400",
			"name": "everything",
			"time": "39.98"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "40.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "shot",
			"time": "40.29"
		},
		{
			"duration": "0.03",
			"confidence": "0.980",
			"name": ".",
			"time": "40.59"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "It",
			"time": "40.62"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "was",
			"time": "40.74"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "fun",
			"time": "40.86"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": ".",
			"time": "41.69"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "There",
			"time": "41.79"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "was",
			"time": "41.91"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "their",
			"time": "42.06"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "own",
			"time": "42.24"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "version",
			"time": "42.39"
		},
		{
			"duration": "0.35",
			"confidence": "0.670",
			"name": "Budapest",
			"time": "42.83"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "version",
			"time": "43.26"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "of",
			"time": "43.56"
		},
		{
			"duration": "0.36",
			"confidence": "0.790",
			"name": "cinnamon",
			"time": "44.25"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "toast",
			"time": "44.61"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "crunch",
			"time": "44.85"
		},
		{
			"duration": "0.03",
			"confidence": "0.900",
			"name": ".",
			"time": "45.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "So",
			"time": "45.60"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "that",
			"time": "45.72"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "45.87"
		},
		{
			"duration": "0.76",
			"confidence": "0.810",
			"name": "interesting",
			"time": "46.02"
		},
		{
			"duration": "0.39",
			"confidence": "0.830",
			"name": ".",
			"time": "46.80"
		},
		{
			"duration": "0.38",
			"confidence": "0.980",
			"name": "And",
			"time": "47.35"
		},
		{
			"duration": "0.21",
			"confidence": "0.920",
			"name": "yeah",
			"time": "49.26"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "after",
			"time": "49.53"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "breakfast",
			"time": "49.77"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "we",
			"time": "50.28"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "loaded",
			"time": "50.79"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "onto",
			"time": "51.51"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "51.78"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "tram",
			"time": "51.87"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "took",
			"time": "52.62"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "52.77"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "tram",
			"time": "52.89"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "down",
			"time": "53.19"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "to",
			"time": "53.37"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "downtown",
			"time": "53.46"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "Budapest",
			"time": "53.85"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "54.93"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "then",
			"time": "55.08"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we",
			"time": "56.49"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "got",
			"time": "56.67"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "56.79"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "two",
			"time": "56.85"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "hour",
			"time": "57.03"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "tour",
			"time": "57.21"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "guide",
			"time": "57.42"
		},
		{
			"duration": "0.45",
			"confidence": "0.750",
			"name": ".",
			"time": "57.81"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "He",
			"time": "58.41"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "was",
			"time": "58.56"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "hilarious",
			"time": "58.68"
		},
		{
			"duration": "0.10",
			"confidence": "0.880",
			"name": ".",
			"time": "59.86"
		},
		{
			"duration": "0.38",
			"confidence": "1.000",
			"name": "Never",
			"time": "60.06"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "been",
			"time": "60.45"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "60.57"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "60.66"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "United",
			"time": "61.05"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "States",
			"time": "61.35"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "but",
			"time": "61.65"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "knew",
			"time": "61.74"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "more",
			"time": "62.28"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "about",
			"time": "62.61"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "62.79"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "United",
			"time": "62.88"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "States",
			"time": "63.12"
		},
		{
			"duration": "0.14",
			"confidence": "0.860",
			"name": "and",
			"time": "63.52"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "all",
			"time": "63.66"
		},
		{
			"duration": "0.06",
			"confidence": "0.960",
			"name": "of",
			"time": "63.90"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "the",
			"time": "63.96"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "history",
			"time": "64.11"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "around",
			"time": "64.44"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "64.65"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "world",
			"time": "64.71"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "than",
			"time": "64.89"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "I",
			"time": "65.01"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "ever",
			"time": "65.34"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "have",
			"time": "65.58"
		},
		{
			"duration": "0.36",
			"confidence": "0.790",
			"name": ".",
			"time": "65.91"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "And",
			"time": "66.36"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "he",
			"time": "68.01"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "gave",
			"time": "68.43"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "us",
			"time": "68.67"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "68.76"
		},
		{
			"duration": "0.18",
			"confidence": "0.870",
			"name": "two",
			"time": "68.82"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "hour",
			"time": "69.00"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "tour",
			"time": "69.18"
		},
		{
			"duration": "0.15",
			"confidence": "0.580",
			"name": "where",
			"time": "69.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we",
			"time": "69.48"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "saw",
			"time": "69.60"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "69.90"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "parliament",
			"time": "70.02"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "building",
			"time": "70.44"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we",
			"time": "71.31"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "saw",
			"time": "71.49"
		},
		{
			"duration": "0.29",
			"confidence": "0.410",
			"name": "uhm",
			"time": "72.30"
		},
		{
			"duration": "0.78",
			"confidence": "0.820",
			"name": ".",
			"time": "72.62"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "What",
			"time": "73.80"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "else",
			"time": "73.95"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "did",
			"time": "74.13"
		},
		{
			"duration": "0.12",
			"confidence": "0.970",
			"name": "we",
			"time": "74.28"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "see",
			"time": "74.40"
		},
		{
			"duration": "0.03",
			"confidence": "0.980",
			"name": ".",
			"time": "74.76"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "We",
			"time": "75.24"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "saw",
			"time": "75.33"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "75.48"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "Basilica",
			"time": "75.57"
		},
		{
			"duration": "0.23",
			"confidence": "0.620",
			"name": ".",
			"time": "77.03"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "The",
			"time": "77.67"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "Michael",
			"time": "77.82"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "Jackson",
			"time": "78.09"
		},
		{
			"duration": "0.21",
			"confidence": "0.970",
			"name": "tree",
			"time": "78.51"
		},
		{
			"duration": "0.18",
			"confidence": "0.940",
			"name": "that's",
			"time": "78.72"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "famous",
			"time": "78.90"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "here",
			"time": "79.23"
		},
		{
			"duration": "0.36",
			"confidence": "0.630",
			"name": ".",
			"time": "80.61"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "Some",
			"time": "81.39"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "other",
			"time": "81.60"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "World",
			"time": "81.96"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "War",
			"time": "82.23"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "memorials",
			"time": "82.65"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "around",
			"time": "83.55"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "83.79"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "river",
			"time": "83.88"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "and",
			"time": "84.48"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "some",
			"time": "85.32"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "really",
			"time": "85.53"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "cool",
			"time": "85.77"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "historical",
			"time": "85.92"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "stuff",
			"time": "86.37"
		},
		{
			"duration": "0.15",
			"confidence": "0.970",
			"name": "that",
			"time": "86.58"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "86.73"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "would",
			"time": "86.88"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "have",
			"time": "86.97"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "never",
			"time": "87.09"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "known",
			"time": "87.30"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "about",
			"time": "87.48"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "just",
			"time": "87.66"
		},
		{
			"duration": "0.25",
			"confidence": "1.000",
			"name": "walking",
			"time": "87.81"
		},
		{
			"duration": "0.17",
			"confidence": "0.930",
			"name": "around",
			"time": "88.06"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "88.23"
		},
		{
			"duration": "0.31",
			"confidence": "1.000",
			"name": "city",
			"time": "88.32"
		},
		{
			"duration": "0.02",
			"confidence": "0.590",
			"name": ".",
			"time": "88.63"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "So",
			"time": "88.65"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "89.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "89.34"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "nice",
			"time": "89.49"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "89.70"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "have",
			"time": "89.76"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "someone",
			"time": "89.88"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "kind",
			"time": "90.12"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "90.27"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "guide",
			"time": "90.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "us",
			"time": "90.60"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "through",
			"time": "90.75"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "91.05"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "one",
			"time": "91.23"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "91.38"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "our",
			"time": "91.47"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "days",
			"time": "91.56"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "here",
			"time": "91.83"
		},
		{
			"duration": "0.57",
			"confidence": "0.990",
			"name": "especially",
			"time": "92.01"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "how",
			"time": "92.88"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "famous",
			"time": "93.09"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Budapest",
			"time": "93.54"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "is",
			"time": "94.08"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "and",
			"time": "94.50"
		},
		{
			"duration": "0.29",
			"confidence": "0.750",
			"name": "what",
			"time": "96.34"
		},
		{
			"duration": "0.18",
			"confidence": "0.570",
			"name": "also",
			"time": "96.84"
		},
		{
			"duration": "0.09",
			"confidence": "0.690",
			"name": "we",
			"time": "97.04"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "do",
			"time": "97.14"
		},
		{
			"duration": "0.27",
			"confidence": "0.970",
			"name": "after",
			"time": "97.65"
		},
		{
			"duration": "0.31",
			"confidence": "0.840",
			"name": "that",
			"time": "97.91"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "we",
			"time": "98.31"
		},
		{
			"duration": "0.85",
			"confidence": "1.000",
			"name": "got",
			"time": "99.00"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "around",
			"time": "100.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "noon",
			"time": "100.53"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we",
			"time": "100.83"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "got",
			"time": "100.95"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "101.22"
		},
		{
			"duration": "0.55",
			"confidence": "1.000",
			"name": "go",
			"time": "101.37"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "kind",
			"time": "101.94"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "102.12"
		},
		{
			"duration": "0.42",
			"confidence": "0.980",
			"name": "explore",
			"time": "102.21"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "Budapest",
			"time": "102.63"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "have",
			"time": "103.23"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "lunch",
			"time": "103.44"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "with",
			"time": "103.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "some",
			"time": "103.95"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "friends",
			"time": "104.10"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "and",
			"time": "104.52"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "shop",
			"time": "105.99"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "106.35"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "little",
			"time": "106.38"
		},
		{
			"duration": "0.25",
			"confidence": "1.000",
			"name": "bit",
			"time": "106.59"
		},
		{
			"duration": "0.04",
			"confidence": "0.800",
			"name": ".",
			"time": "106.84"
		},
		{
			"duration": "0.07",
			"confidence": "0.700",
			"name": "I",
			"time": "106.90"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "did",
			"time": "106.98"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "some",
			"time": "107.16"
		},
		{
			"duration": "0.24",
			"confidence": "0.670",
			"name": "shop",
			"time": "107.34"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "sorry",
			"time": "107.61"
		},
		{
			"duration": "0.27",
			"confidence": "0.900",
			"name": "mom",
			"time": "107.92"
		},
		{
			"duration": "0.36",
			"confidence": "0.860",
			"name": "dad",
			"time": "108.38"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "and",
			"time": "110.43"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "we",
			"time": "112.89"
		},
		{
			"duration": "0.37",
			"confidence": "0.980",
			"name": "had",
			"time": "113.04"
		},
		{
			"duration": "0.28",
			"confidence": "0.410",
			"name": "let's",
			"time": "113.49"
		},
		{
			"duration": "0.18",
			"confidence": "0.840",
			"name": "let's",
			"time": "113.90"
		},
		{
			"duration": "0.25",
			"confidence": "0.880",
			"name": "see",
			"time": "114.10"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "I",
			"time": "114.36"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "had",
			"time": "114.48"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "pizza",
			"time": "114.60"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "for",
			"time": "114.93"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "lunch",
			"time": "115.05"
		},
		{
			"duration": "0.43",
			"confidence": "0.960",
			"name": "again",
			"time": "115.29"
		},
		{
			"duration": "0.04",
			"confidence": "0.800",
			"name": ".",
			"time": "115.72"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "I",
			"time": "115.77"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "can't",
			"time": "115.83"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "get",
			"time": "116.04"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "enough",
			"time": "116.13"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "pizza",
			"time": "116.31"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "over",
			"time": "116.55"
		},
		{
			"duration": "0.14",
			"confidence": "1.000",
			"name": "here",
			"time": "116.73"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "it's",
			"time": "116.88"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "so",
			"time": "117.00"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "good",
			"time": "117.27"
		},
		{
			"duration": "0.17",
			"confidence": "0.700",
			"name": ".",
			"time": "117.63"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "They",
			"time": "117.87"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "gave",
			"time": "117.99"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "me",
			"time": "118.17"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "scissors",
			"time": "118.32"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "118.77"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "cut",
			"time": "118.89"
		},
		{
			"duration": "0.08",
			"confidence": "0.720",
			"name": "it",
			"time": "119.08"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "instead",
			"time": "119.16"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "119.43"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "119.52"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "knife",
			"time": "119.55"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "which",
			"time": "119.85"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "was",
			"time": "120.00"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "interesting",
			"time": "120.12"
		},
		{
			"duration": "0.46",
			"confidence": "0.880",
			"name": ".",
			"time": "120.83"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "And",
			"time": "121.47"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "after",
			"time": "123.24"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "lunch",
			"time": "123.51"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "we",
			"time": "123.75"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "all",
			"time": "123.84"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "met",
			"time": "123.93"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "up",
			"time": "124.11"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "and",
			"time": "125.13"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "we",
			"time": "125.58"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "went",
			"time": "126.75"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "back",
			"time": "126.90"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "into",
			"time": "127.14"
		},
		{
			"duration": "0.47",
			"confidence": "1.000",
			"name": "town",
			"time": "127.41"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "took",
			"time": "127.89"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "128.07"
		},
		{
			"duration": "0.30",
			"confidence": "0.940",
			"name": "tram",
			"time": "128.16"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "back",
			"time": "128.46"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "to",
			"time": "128.67"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "129.06"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "hotel",
			"time": "129.15"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "129.96"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "then",
			"time": "130.11"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "got",
			"time": "130.50"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "ready",
			"time": "130.71"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "130.95"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "go",
			"time": "131.07"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "131.28"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "our",
			"time": "131.43"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "match",
			"time": "131.55"
		},
		{
			"duration": "0.32",
			"confidence": "0.980",
			"name": "today",
			"time": "132.44"
		},
		{
			"duration": "0.17",
			"confidence": "0.570",
			"name": "verse",
			"time": "132.77"
		},
		{
			"duration": "0.31",
			"confidence": "0.620",
			"name": ".",
			"time": "133.28"
		},
		{
			"duration": "0.13",
			"confidence": "0.980",
			"name": "Was",
			"time": "133.93"
		},
		{
			"duration": "0.07",
			"confidence": "0.350",
			"name": "at",
			"time": "134.09"
		},
		{
			"duration": "0.06",
			"confidence": "0.970",
			"name": "a",
			"time": "134.16"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "Hungarian",
			"time": "134.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "club",
			"time": "134.67"
		},
		{
			"duration": "0.33",
			"confidence": "0.980",
			"name": "team",
			"time": "134.88"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "national",
			"time": "135.33"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "team",
			"time": "135.66"
		},
		{
			"duration": "0.83",
			"confidence": "0.770",
			"name": ".",
			"time": "135.93"
		},
		{
			"duration": "0.09",
			"confidence": "0.960",
			"name": "The",
			"time": "137.00"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "Hungarian",
			"time": "137.10"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "club",
			"time": "137.61"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "team",
			"time": "137.85"
		},
		{
			"duration": "0.07",
			"confidence": "0.690",
			"name": ".",
			"time": "138.15"
		},
		{
			"duration": "0.64",
			"confidence": "0.990",
			"name": "And",
			"time": "138.25"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "after",
			"time": "140.55"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "playing",
			"time": "140.79"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "these",
			"time": "141.00"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "girls",
			"time": "141.12"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "we",
			"time": "141.33"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "sat",
			"time": "141.42"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "down",
			"time": "141.63"
		},
		{
			"duration": "0.06",
			"confidence": "0.940",
			"name": "at",
			"time": "141.87"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "141.93"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "nice",
			"time": "142.02"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "dinner",
			"time": "142.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "across",
			"time": "142.50"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "142.80"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "street",
			"time": "142.86"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "from",
			"time": "143.10"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "our",
			"time": "143.28"
		},
		{
			"duration": "0.42",
			"confidence": "0.990",
			"name": "gym",
			"time": "143.46"
		},
		{
			"duration": "0.39",
			"confidence": "0.990",
			"name": "which",
			"time": "144.18"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "learned",
			"time": "145.50"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "not",
			"time": "145.71"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "145.86"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "judge",
			"time": "145.95"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "146.16"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "book",
			"time": "146.22"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "by",
			"time": "146.40"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "its",
			"time": "146.52"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "cover",
			"time": "146.64"
		},
		{
			"duration": "0.17",
			"confidence": "0.810",
			"name": "because",
			"time": "146.94"
		},
		{
			"duration": "0.30",
			"confidence": "0.620",
			"name": ".",
			"time": "147.90"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "Let",
			"time": "148.74"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "me",
			"time": "148.83"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "tell",
			"time": "148.95"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "149.13"
		},
		{
			"duration": "0.23",
			"confidence": "0.680",
			"name": "guys",
			"time": "149.22"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "150.33"
		},
		{
			"duration": "0.24",
			"confidence": "0.970",
			"name": "looked",
			"time": "150.48"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "like",
			"time": "150.72"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "150.87"
		},
		{
			"duration": "0.33",
			"confidence": "0.970",
			"name": "dive",
			"time": "150.93"
		},
		{
			"duration": "0.27",
			"confidence": "0.460",
			"name": "gaoli",
			"time": "151.26"
		},
		{
			"duration": "0.33",
			"confidence": "0.920",
			"name": "Winters",
			"time": "151.53"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "said",
			"time": "151.86"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "I",
			"time": "153.33"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hope",
			"time": "153.96"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "there's",
			"time": "154.17"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "not",
			"time": "154.32"
		},
		{
			"duration": "0.12",
			"confidence": "0.580",
			"name": "a",
			"time": "154.47"
		},
		{
			"duration": "0.16",
			"confidence": "0.660",
			"name": "nail",
			"time": "154.59"
		},
		{
			"duration": "0.35",
			"confidence": "1.000",
			"name": "sticking",
			"time": "154.75"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "out",
			"time": "155.10"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "155.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "155.25"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "ground",
			"time": "155.37"
		},
		{
			"duration": "0.42",
			"confidence": "0.630",
			"name": "diving",
			"time": "156.02"
		},
		{
			"duration": "0.30",
			"confidence": "0.960",
			"name": "here",
			"time": "156.74"
		},
		{
			"duration": "0.30",
			"confidence": "0.580",
			"name": ".",
			"time": "157.04"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "And",
			"time": "157.35"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "then",
			"time": "157.44"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we",
			"time": "157.53"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "walk",
			"time": "157.65"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "157.89"
		},
		{
			"duration": "0.09",
			"confidence": "0.970",
			"name": "and",
			"time": "158.01"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "it's",
			"time": "158.10"
		},
		{
			"duration": "0.65",
			"confidence": "1.000",
			"name": "beautiful",
			"time": "158.28"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "the",
			"time": "158.94"
		},
		{
			"duration": "0.26",
			"confidence": "0.980",
			"name": "floor",
			"time": "159.24"
		},
		{
			"duration": "0.10",
			"confidence": "0.980",
			"name": "is",
			"time": "159.50"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "like",
			"time": "159.60"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "159.78"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "new",
			"time": "159.87"
		},
		{
			"duration": "0.30",
			"confidence": "0.880",
			"name": "Terra",
			"time": "160.05"
		},
		{
			"duration": "0.50",
			"confidence": "0.580",
			"name": "flex",
			"time": "160.35"
		},
		{
			"duration": "0.57",
			"confidence": "0.940",
			"name": ".",
			"time": "161.20"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "There",
			"time": "161.79"
		},
		{
			"duration": "0.06",
			"confidence": "0.950",
			"name": "are",
			"time": "161.97"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "bleachers",
			"time": "162.03"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "162.45"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "were",
			"time": "162.57"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "set",
			"time": "162.69"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "out",
			"time": "162.93"
		},
		{
			"duration": "0.03",
			"confidence": "0.850",
			"name": ".",
			"time": "163.11"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "It",
			"time": "163.14"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "163.23"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "really",
			"time": "163.38"
		},
		{
			"duration": "0.29",
			"confidence": "1.000",
			"name": "pretty",
			"time": "163.65"
		},
		{
			"duration": "0.09",
			"confidence": "0.450",
			"name": ".",
			"time": "163.94"
		},
		{
			"duration": "0.46",
			"confidence": "0.760",
			"name": "So",
			"time": "164.03"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "it",
			"time": "165.39"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "165.45"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "actually",
			"time": "165.60"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "166.29"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "sight",
			"time": "166.32"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "for",
			"time": "166.53"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "sore",
			"time": "166.62"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "eyes",
			"time": "166.86"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "167.19"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "some",
			"time": "167.34"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "167.49"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "167.55"
		},
		{
			"duration": "0.23",
			"confidence": "0.380",
			"name": "Dimsey",
			"time": "167.61"
		},
		{
			"duration": "0.19",
			"confidence": "0.300",
			"name": "play",
			"time": "167.86"
		},
		{
			"duration": "0.23",
			"confidence": "1.000",
			"name": "and",
			"time": "168.13"
		},
		{
			"duration": "0.14",
			"confidence": "0.980",
			"name": "had",
			"time": "168.37"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "air",
			"time": "168.51"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "conditioning",
			"time": "168.63"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "which",
			"time": "169.11"
		},
		{
			"duration": "0.15",
			"confidence": "0.970",
			"name": "was",
			"time": "169.26"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "awesome",
			"time": "169.41"
		},
		{
			"duration": "0.49",
			"confidence": "0.830",
			"name": "finally",
			"time": "170.19"
		},
		{
			"duration": "0.20",
			"confidence": "0.590",
			"name": ".",
			"time": "170.68"
		},
		{
			"duration": "0.41",
			"confidence": "0.800",
			"name": "So",
			"time": "171.12"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we",
			"time": "172.62"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "played",
			"time": "172.74"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "five",
			"time": "172.95"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "sets",
			"time": "173.16"
		},
		{
			"duration": "0.12",
			"confidence": "0.900",
			"name": "with",
			"time": "173.37"
		},
		{
			"duration": "0.06",
			"confidence": "0.920",
			"name": "the",
			"time": "173.49"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "Hungarian",
			"time": "173.55"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "team",
			"time": "173.91"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "today",
			"time": "174.06"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "174.30"
		},
		{
			"duration": "0.07",
			"confidence": "0.820",
			"name": "then",
			"time": "174.39"
		},
		{
			"duration": "0.07",
			"confidence": "1.000",
			"name": "we",
			"time": "174.47"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "went",
			"time": "174.54"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "across",
			"time": "174.69"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "175.02"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "had",
			"time": "175.11"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "dinner",
			"time": "175.23"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "and",
			"time": "176.10"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "Hungarian",
			"time": "177.72"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "or",
			"time": "178.62"
		},
		{
			"duration": "0.08",
			"confidence": "0.840",
			"name": "is",
			"time": "179.28"
		},
		{
			"duration": "0.15",
			"confidence": "0.940",
			"name": "that",
			"time": "179.39"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "179.55"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "language",
			"time": "179.61"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "is",
			"time": "180.66"
		},
		{
			"duration": "0.32",
			"confidence": "0.530",
			"name": "harsh",
			"time": "180.84"
		},
		{
			"duration": "0.19",
			"confidence": "0.870",
			"name": ".",
			"time": "181.16"
		},
		{
			"duration": "0.19",
			"confidence": "0.620",
			"name": "It's",
			"time": "181.36"
		},
		{
			"duration": "0.31",
			"confidence": "0.980",
			"name": "very",
			"time": "181.63"
		},
		{
			"duration": "0.45",
			"confidence": "0.990",
			"name": "tricky",
			"time": "181.95"
		},
		{
			"duration": "0.00",
			"confidence": "1.000",
			"name": ".",
			"time": "184.0"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/sports.json
// module id = 29
// module chunks = 0